import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Select } from '@/elements';
import './index.scss';

const EvacuationReplaySelect = memo(({ list, ...rest }) => (
	<Fragment>
		{!!list.length && (
			<Select {...rest} className="evacuation-sites-select">
				<Select.Option key="none" value={null}>
					{rest.placeholder}
				</Select.Option>
				{list
					.sort((a, b) =>
						moment(b.startTime).diff(moment(a.startTime)),
					)
					.map((el, index) => (
						<Select.Option
							key={index}
							value={el.startTime}
							disabled={rest.value === el.startTime}
						>
							PAST EVACUATION{' '}
							{moment(el.startTime).format(
								'DD/MM/YYYY - HH:mm:ss',
							)}
						</Select.Option>
					))}
			</Select>
		)}
	</Fragment>
));

EvacuationReplaySelect.defaultProps = {
	list: [],
};

EvacuationReplaySelect.propTypes = {
	list: PropTypes.array.isRequired,
};

export default EvacuationReplaySelect;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-replay-select/index.js